import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'mention-notification.permission-space-or-parent-database-restriction-one-user': {
    id: 'mention-notification.permission-space-or-parent-database-restriction-one-user',
    defaultMessage:
      '{displayName} needs space or parent database access, so we can’t let them know you mentioned them',
    description:
      'Error text when a user doesn’t have access to either the space or a parent database'
  },
  'mention-notification.permission-database-restriction-one-user': {
    id: 'mention-notification.permission-database-restriction-one-user',
    defaultMessage:
      '{displayName} doesn’t have access to this database, so we can’t let them know you mentioned them',
    description: 'Error text when a user doesn’t have access to the database'
  },
  'mention-notification.permission-database-restriction-fallback-user': {
    id: 'mention-notification.permission-database-restriction-fallback-user',
    defaultMessage: 'The mentioned user',
    description: 'Fallback text for mentioned user on a restricted database'
  },
  'mention-notification.permission-database-restriction-two-users': {
    id: 'mention-notification.permission-database-restriction-two-users',
    defaultMessage:
      '{displayName} and {somebodyElse} have restrictions, so we can’t let them know you mentioned them',
    description: 'Error text when two users do not hav access to the database'
  },
  'mention-notification.permission-database-restriction-three-or-more-users': {
    id: 'mention-notification.permission-database-restriction-three-or-more-users',
    defaultMessage:
      '{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} have restrictions, so we can’t let them know you mentioned them',
    description: 'Error text when three or more users do not hav access to the database'
  },
  'mention-notification.flag-permission-restriction-title-one-user': {
    id: 'mention-notification.flag-permission-restriction-title-one-user',
    defaultMessage: '{displayName} won’t be notified',
    description: 'Flag title text when one user does not have access to database'
  },
  'mention-notification.flag-permission-restriction-title-two-users': {
    id: 'mention-notification.flag-permission-restriction-title-two-users',
    defaultMessage: '{displayName} and {somebodyElse} won’t be notified',
    description: 'Flag title text when two users do not have access to database'
  },
  'mention-notification.flag-permission-restriction-title-three-or-more-users': {
    id: 'mention-notification.flag-permission-restriction-title-three-or-more-users',
    defaultMessage:
      '{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} won’t be notified',
    description: 'Flag title text when three or more users do not have access to database'
  },
  'mention-notification.flag-permission-restriction-description': {
    id: 'mention-notification.flag-permission-restriction-description',
    defaultMessage:
      'They don’t have access to this database, so we can’t let them know you mentioned them.',
    description: 'Flag description text when user(s) do not have access to database'
  },
  'mention-notification.flag-permission-parent-restriction-description': {
    id: 'mention-notification.flag-permission-parent-restriction-description',
    defaultMessage:
      'They don’t have access to the parent item, so we can’t let them know you mentioned them.',
    description: 'Flag description text when user(s) do not have access to parent item'
  },
  'mention-notification.flag-permission-space-restriction-description': {
    id: 'mention-notification.flag-permission-space-restriction-description',
    defaultMessage:
      'They don’t have access to the space, so we can’t let them know you mentioned them.',
    description: 'Flag description text when user(s) do not have access to parent item'
  },
  'mention-notification.flag-permission-mixed-restriction-description': {
    id: 'mention-notification.flag-permission-mixed-restriction-description',
    defaultMessage:
      'They don’t have access to this database, its parent item, or the space. We can’t let them know you mentioned them.',
    description:
      'Flag description text when user(s) do not have access to the database, its parent item, or the space'
  },
  'mention-notification.flag-mention-notification-title-one-user': {
    id: 'mention-notification.flag-mention-notification-title-one-user',
    defaultMessage: '{displayName} will be notified',
    description: 'Flag title text when one user is mentioned'
  },
  'mention-notification.flag-mention-notification-title-two-users': {
    id: 'mention-notification.flag-mention-notification-title-two-users',
    defaultMessage: '{displayName} and {somebodyElse} will be notified',
    description: 'Flag title text when two users are mentioned'
  },
  'mention-notification.flag-mention-notification-title-three-or-more-users': {
    id: 'mention-notification.flag-mention-notification-title-three-or-more-users',
    defaultMessage:
      '{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} will be notified',
    description: 'Flag title text when three or more user are mentioned'
  },
  'mention-notification.flag-mention-notification-description-legacy': {
    id: 'mention-notification.flag-mention-notification-description-legacy',
    defaultMessage:
      'We’ll let them know you mentioned them. Turn user notifications off in field settings.',
    description: 'Flag description text when user(s) are mentioned'
  },
  'mention-notification.flag-mention-notification-description': {
    id: 'mention-notification.flag-mention-notification-description',
    defaultMessage: 'You can turn off notifications for this field at any time.',
    description:
      'Flag description text when user(s) are mentioned and field settings open in the contextual menu'
  },
  'mention-notification.flag-mention-notification-description-without-field-settings': {
    id: 'mention-notification.flag-mention-notification-description-without-field-settings',
    defaultMessage: 'We’ll let them know you mentioned them.',
    description:
      'Flag description text when user(s) are mentioned in a locked structure database.'
  },
  'mention-notification.flag-error-title': {
    id: 'mention-notification.flag-error-title',
    defaultMessage: 'Something went wrong',
    description: 'Flag title text when create mention fails'
  },
  'mention-notification.flag-error-description': {
    id: 'mention-notification.flag-error-description',
    defaultMessage: 'Please try again later.',
    description: 'Flag description text create mention fails'
  },
  'mention-notification.flag-go-to-field-settings-cta': {
    id: 'mention-notification.flag-go-to-field-settings-cta',
    defaultMessage: 'Go to field settings',
    description: 'CTA text to open field settings in a flag'
  },
  'mention-notification.flag-edit-field-settings-cta': {
    id: 'mention-notification.flag-edit-field-settings-cta',
    defaultMessage: 'Edit field settings',
    description: 'CTA text to open field settings in the contextual menu from a flag'
  }
});
